// yyyy-mm-ddThh-mm-ssZ 값을 datetime으로 변경하기 위한 함수

// local값이 왔을 때
export const datetimeLocalCalculator = (datetimeLocalValue) => {
    if (!datetimeLocalValue) return null

    const date = new Date(datetimeLocalValue)
    date.setHours(date.getHours())

    const yyyy = date.getFullYear()
    const mm = String(date.getMonth() + 1).padStart(2, "0")
    const dd = String(date.getDate()).padStart(2, "0")
    const hh = String(date.getHours()).padStart(2, "0")
    const min = String(date.getMinutes()).padStart(2, "0")
    const sec = String(date.getSeconds()).padStart(2, "0")

    return `${yyyy}-${mm}-${dd} ${hh}:${min}:${sec}`
}

// utc값이 왔을 때
export const datetimeLocalValueCalculator = (utcISOString) => {
    if (!utcISOString) return null

    const utcDate = new Date(utcISOString)
    utcDate.setHours(utcDate.getHours() - 9)

    const yyyy = utcDate.getFullYear()
    const mm = String(utcDate.getMonth() + 1).padStart(2, "0")
    const dd = String(utcDate.getDate()).padStart(2, "0")
    const hh = String(utcDate.getHours()).padStart(2, "0")
    const min = String(utcDate.getMinutes()).padStart(2, "0")

    return `${yyyy}-${mm}-${dd}T${hh}:${min}`
}